import { render, staticRenderFns } from "./FreeGiftContainer.vue?vue&type=template&id=7b741530&"
import script from "./FreeGiftContainer.vue?vue&type=script&lang=ts&"
export * from "./FreeGiftContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports